module.exports = __webpack_public_path__ + "media/tts_g1_i.ce7e5cc4.mp3";